// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3dYr9","title":"AfterFrontImage_title__3FmIV"};